import type { Pet, PetSpecies, Rarity } from '../types';

// 시트 애니메이션 적용 30종 — pet_sheet.png 행 순서와 동일
type SpeciesEntry = { species: PetSpecies; name: string; rarity: Rarity };

const SPECIES_TABLE: SpeciesEntry[] = [
  // 0-3 hand-authored
  { species: 'dog',      name: '뽀삐',     rarity: 'common' },
  { species: 'cat',      name: '나비',     rarity: 'common' },
  { species: 'rabbit',   name: '토비',     rarity: 'rare'   },
  { species: 'hamster',  name: '햄찌',     rarity: 'rare'   },
  // 4-23 quadrupeds
  { species: 'fox',      name: '여리',     rarity: 'rare'   },
  { species: 'bear',     name: '곰탱이',   rarity: 'rare'   },
  { species: 'panda',    name: '판판이',   rarity: 'epic'   },
  { species: 'wolf',     name: '늑돌이',   rarity: 'epic'   },
  { species: 'tiger',    name: '호돌이',   rarity: 'epic'   },
  { species: 'lion',     name: '라이온',   rarity: 'epic'   },
  { species: 'raccoon',  name: '라쿤',     rarity: 'rare'   },
  { species: 'squirrel', name: '다람이',   rarity: 'common' },
  { species: 'pig',      name: '꿀꿀이',   rarity: 'common' },
  { species: 'sheep',    name: '메리',     rarity: 'common' },
  { species: 'cow',      name: '얼룩이',   rarity: 'common' },
  { species: 'deer',     name: '루돌프',   rarity: 'rare'   },
  { species: 'elephant', name: '코코',     rarity: 'epic'   },
  { species: 'monkey',   name: '몽키',     rarity: 'rare'   },
  { species: 'koala',    name: '코알라',   rarity: 'rare'   },
  { species: 'hedgehog', name: '고슴이',   rarity: 'rare'   },
  { species: 'unicorn',  name: '유니',     rarity: 'legend' },
  { species: 'ferret',   name: '페렛',     rarity: 'rare'   },
  { species: 'alpaca',   name: '알파',     rarity: 'rare'   },
  { species: 'capybara', name: '카피',     rarity: 'common' },
  // 24-29 specials
  { species: 'dragon',   name: '드래곤',   rarity: 'legend' },
  { species: 'penguin',  name: '뽀로로',   rarity: 'rare'   },
  { species: 'bird',     name: '짹짹이',   rarity: 'common' },
  { species: 'owl',      name: '부엉이',   rarity: 'rare'   },
  { species: 'butterfly',name: '나비요정', rarity: 'epic'   },
  { species: 'turtle',   name: '거북이',   rarity: 'rare'   },
];

export const PETS: Pet[] = SPECIES_TABLE.map((e, i) => ({
  id: `pet_${e.species}`,
  species: e.species,
  name: e.name,
  rarity: e.rarity,
  // 첫 번째(뽀삐)만 starter, 나머지는 모두 알 부화로 획득
  unlockMethod: i === 0 ? 'starter' : 'egg',
}));

export const PETS_BY_ID: Record<string, Pet> = Object.fromEntries(PETS.map(p => [p.id, p]));
export const PETS_FOR_EGG: Pet[] = PETS.filter(p => p.unlockMethod === 'egg');
